<template lang="pug">
.dropdown
    button.btn.btn-sm.btn-light.dropdown-toggle(@click.prevent="toggle") {{ label }}
    .dropdown-menu(:class="{ show }")
        slot
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            show: false
        }
    },
    mounted () {
        document.addEventListener('click', this.close)
    },
    beforeDestroy () {
        document.removeEventListener('click', this.close)
    },
    methods: {
        toggle (e) {
            this.show = !this.show
        },
        close (e) {
            if (!this.$el.contains(e.target)) {
                this.show = false
            }
        }
    }
}
</script>
